class Interview {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
  }

  event() {
    (() => {
      const swiperEl = document.querySelector(".js-swiper-interview");
      if (!swiperEl) return;

      const slides = swiperEl.querySelectorAll(".swiper-slide");
      const slideCount = slides.length;

      var interviewSwiper = new Swiper(".js-swiper-interview", {
        slidesPerView: 1.5,
        centeredSlides: true,
        loop: true,
        spaceBetween: 16,
        speed: 1000,
        autoplay: {
          delay: 1000,
          disableOnInteraction: true
        },
        breakpoints: {
          768: {
            slidesPerView: 3.7,
            spaceBetween: 40,
            centeredSlides: false,
          }
        },
        pagination: {
          el: ".js-swiper-interview-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".js-swiper-interview-next",
          prevEl: ".js-swiper-interview-prev",
        },
      });

      document.querySelector(".js-swiper-interview-stop").addEventListener("click", function () {
        interviewSwiper.autoplay.stop();
      });

      // const mql = window.matchMedia("(min-width: 768px)");

      // let interviewSwiper = null;

      // const initSwiper = (isPC) => {
      //   return new Swiper(".js-swiper-interview", {
      //     slidesPerView: 1.5,
      //     centeredSlides: true,
      //     loop: true,
      //     spaceBetween: 16,
      //     speed: 2000,
      //     autoplay: {
      //       delay: 1000,
      //       disableOnInteraction: true,
      //     },
      //     pagination: {
      //       el: ".js-swiper-interview-pagination",
      //       clickable: true,
      //     },
      //     navigation: {
      //       nextEl: ".js-swiper-interview-next",
      //       prevEl: ".js-swiper-interview-prev",
      //     },
      //     breakpoints: {
      //       768: {
      //         slidesPerView: 3.7,
      //         spaceBetween: 40,
      //       },
      //     },
      //   });
      // };

      // const checkAndInitSwiper = () => {
      //   const isPC = mql.matches;

      //   const shouldDisable =
      //     (isPC && slideCount < 4) || (!isPC && slideCount < 2);

      //   if (interviewSwiper) {
      //     interviewSwiper.destroy(true, true);
      //     interviewSwiper = null;
      //     swiperEl.classList.remove("is-swiper-enabled");
      //   }

      //   if (!shouldDisable) {
      //     interviewSwiper = initSwiper(isPC);
      //     swiperEl.classList.add("is-swiper-enabled");
      //     swiperEl.classList.remove("is-static");
      //   } else {
      //     swiperEl.classList.add("is-static");
      //   }
      // };

      // checkAndInitSwiper();

      // mql.addEventListener("change", checkAndInitSwiper);

      // const stopBtn = document.querySelector(".js-swiper-interview-stop");
      // if (stopBtn) {
      //   stopBtn.addEventListener("click", () => {
      //     if (interviewSwiper && interviewSwiper.autoplay) {
      //       interviewSwiper.autoplay.stop();
      //     }
      //   });
      // }
    })();
  }
}
